import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ContentContainer, GoogleDFP, SwellEventCardContainer } from '@surfline/quiver-react';
import { slugify, buoySubregionUrl, idealConditionsUrl } from '@surfline/web-common';
import { spotReportPath, spotForecastPath } from '@surfline/web-common/dist/paths/kbyg';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import SpotPageMeta from '../../../components/SpotPageMeta';
import loadAdConfig from '../../../utils/adConfig';
import config from '../../../config';
import SpotCurrentConditionsSection from './SpotCurrentConditionsSection';
import ForecastDataVisualizer from '../../ForecastDataVisualizer';
import IdealConditions from '../../../components/IdealConditions';
import PageLoading from '../../../components/PageLoading';
import ForecastHeader from '../../../components/ForecastHeader';
import RegistrationModals from '../../../components/RegistrationModals';
import DeepLinkModal from '../../../components/DeepLinkModal';
import { fetchSwellEvents } from '../../../actions/swellEvents';
import { setRecentlyVisited, toggleFavorite } from '../../../actions/user';
import {
  fetchSpotReport,
  fetchNearbySpots,
  fetchIdealConditions,
  fetchFeaturedContent,
  fetchBuoys,
} from '../../../actions/spot';
import { fetchPremiumPerks } from '../../../actions/promotions';
import { getPremiumPerks } from '../../../selectors/promotions';
import { premiumPerksPropType } from '../../../propTypes/promotions';
import { trackEvent, navigatedToPage } from '../../../actions/segmentEvents';
import { fetchOverviewData, fetchRegionalArticles } from '../../../actions/subregion';
import { leaveSpotRoute } from '../../../actions/routes';
import { fetchOSData } from '../../../actions/deviceData';
import {
  getUserDetails,
  getUserSettings,
  getUserFavorites,
  getPremiumStatus,
  getUserEntitlements,
} from '../../../selectors/user';
import {
  getSpotDetails,
  getSpotMultiCam,
  getSpotReport,
  getNearbySpots,
  getSpotReportAssociated,
  getSpotId,
  getLegacySubregionId,
  getLegacySpotId,
  getSpotIdealConditions,
  getAdvertisingIds,
  getFeaturedContent,
  getSpotBuoys,
  getSpotReportData,
} from '../../../selectors/spot';
import { getSubregionAssociated } from '../../../selectors/subregion';
import getSwellEvents from '../../../selectors/swellEvents';
import getTreatments from '../../../selectors/treatments';
import { getOSData } from '../../../selectors/deviceData';
import userDetailsPropType from '../../../propTypes/userDetails';
import userSettingsPropTypes from '../../../propTypes/userSettings';
import spotAssociatedPropTypes from '../../../propTypes/spotAssociated';
import userFavoritesPropType from '../../../propTypes/userFavorites';
import featuredContentPropType from '../../../propTypes/featuredContent';
import devicePropTypes from '../../../propTypes/device';
import spotIdealConditionsPropShape from '../../../propTypes/spotIdealConditions';
import spotReportDataPropTypes from '../../../propTypes/spot';
import swellEventsPropType from '../../../propTypes/swellEvents';
import treatmentsPropType from '../../../propTypes/treatments';
import canUseDom from '../../../common/canUseDom';
import en from '../../../intl/translations/en';
import PremiumBenefitsCenter from '../../../components/PremiumBenefitsCenter';
import FeaturedContent from '../../../components/FeaturedContent';
import NearbyBuoys from '../../../components/NearbyBuoys';
import withPageViews from '../../../common/withPageViews';
import articlePropTypes from '../../../propTypes/article';
import multiCamPropType from '../../../propTypes/multiCam';
import osDataPropType from '../../../propTypes/osData';

class SpotPage extends Component {
  static fetch = [
    ({ spotId }, { cookies }) => dispatch =>
      dispatch(
        fetchSpotReport(
          { spotId },
          async spotReport => {
            await Promise.all([
              dispatch(fetchNearbySpots(spotId, cookies)),
              dispatch(fetchRegionalArticles(spotReport.spot.subregion._id, cookies)),
              dispatch(fetchFeaturedContent(cookies)),
            ]);
          },
          cookies
        )
      ),
    (_, { headers }) => fetchOSData(headers),
  ];

  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    const {
      match: {
        params: { spotId },
      },
      userDetails,
      spot,
      nearbySpots,
      doFetchSpotReport,
      doSetRecentlyVisited,
      doFetchNearbySpots,
      legacySpotId,
      doFetchIdealConditions,
      doFetchRegionalArticles,
      doFetchsubregionAssociated,
      doFetchSpotSwellEvents,
      reportData,
      doNavigatedToPage,
      feed,
      premiumPerks,
      doFetchPremiumPerks,
      isPremium,
    } = this.props;

    if (spot && reportData) {
      this.timer = setTimeout(() => {
        this.handleNavigatedToPage(
          spotId,
          spot,
          reportData,
          doNavigatedToPage,
          // eslint-disable-next-line react/destructuring-assignment
          this.props.device,
          isPremium
        );
      }, 0);
    }

    if (!spot) {
      doFetchSpotReport(spotId);
    } else if (userDetails) {
      doSetRecentlyVisited(spotId, spot.name);
    }
    if (!feed && spot) {
      doFetchRegionalArticles(spot.subregion._id);
    }
    if (spot) {
      doFetchsubregionAssociated(spot.subregion._id);
    }
    if (!nearbySpots) {
      doFetchNearbySpots(spotId);
    }
    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.overflowY = 'auto';

    if (legacySpotId) {
      doFetchIdealConditions(legacySpotId);
    }

    doFetchSpotSwellEvents(spotId);

    if (!premiumPerks.perks) {
      doFetchPremiumPerks();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { spotId },
      },
      userDetails,
      spot,
      doFetchSpotReport,
      doFetchNearbySpots,
      doSetRecentlyVisited,
      doFetchIdealConditions,
      doFetchsubregionAssociated,
      legacySpotId,
      doNavigatedToPage,
      reportData,
      device,
      isPremium,
    } = this.props;

    if (prevProps.match.params.spotId !== spotId) {
      doFetchSpotReport(spotId);
    }

    if (prevProps.match.params.spotId !== spotId) {
      doFetchNearbySpots(spotId);
    }

    if (userDetails && spot && spot !== prevProps.spot) {
      doSetRecentlyVisited(spotId, spot.name);
    }

    if (legacySpotId !== prevProps.legacySpotId) {
      doFetchIdealConditions(legacySpotId);
    }

    if (spot && !prevProps.spot) {
      doFetchsubregionAssociated(spot.subregion._id);
    }

    if (spot && prevProps?.spot?.name !== spot?.name) {
      // Have to use setTimeout here so that the title property is accurate
      // Without this, the event fires before react-helmet updates the title tag
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.handleNavigatedToPage(spotId, spot, reportData, doNavigatedToPage, device, isPremium);
      }, 0);
    }
  }

  componentWillUnmount() {
    const { doLeaveSpotRoute } = this.props;
    document.documentElement.style.overflow = null;
    doLeaveSpotRoute();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  handleNavigatedToPage = (spotId, spot, reportData, doNavigatedToPage, device, isPremium) => {
    const getIsSingleCam = () => {
      // return null if spot has no cams
      if (!spot.cameras.length) return null;
      // return false if mulitcam is displayed: multicam spot, premium user, desktop viewport
      if (isPremium && !device.mobile && spot.cameras.length > 1) return false;
      return true;
    };
    const isSingleCam = getIsSingleCam();
    const getCamId = () => {
      // return null if spot has no cams
      if (!spot.cameras.length) return null;
      // return first camId if single cam view
      if (isSingleCam) return spot.cameras[0]._id;
      // return list of all spot camIds
      return spot.cameras.map(cam => cam._id).join();
    };
    doNavigatedToPage('Spot Report', {
      category: 'cams & reports',
      spotId,
      spotName: spot.name,
      subregionId: spot.subregion._id,
      condition: reportData.conditions.value,
      human: reportData.conditions.human,
      hasCam: !!spot.cameras.length,
      premiumCam: !!spot.cameras.length && spot.cameras[0].isPremium,
      waveHeightMin: reportData.waveHeight.min,
      waveHeightMax: reportData.waveHeight.max,
      abilityLevels:
        spot.abilityLevels && spot.abilityLevels.length ? spot.abilityLevels.join() : null,
      boardTypes: spot.boardTypes && spot.boardTypes.length ? spot.boardTypes.join() : null,
      camId: getCamId(),
      camNamePrimary: spot.cameras.length ? spot.cameras[0].title : null,
      isSingleCam,
      isMobileView: !!device.mobile,
    });
  };

  spotFavorited = (favorites, spotId) => !!favorites.find(favorite => favorite._id === spotId);

  handleFavoriteClick = (favorited, spotId) => {
    const { savingFavorite, userDetails, doToggleFavorite } = this.props;
    if (!savingFavorite && !!userDetails) {
      doToggleFavorite(!favorited, spotId);
    } else if (canUseDom) {
      window.location.href = `${
        config.createAccountUrl
      }?alert=noAuthFav&redirectUrl=${encodeURIComponent(window.location)}`;
    }
  };

  /* TODO: Add page level spot page react-router paths */
  renderPageLevelLinks = (name, _id) => [
    {
      text: en.SpotPage.pageLevelLinkText.today.text,
      title: en.SpotPage.pageLevelLinkText.today.title(name),
      path: spotReportPath(slugify(name), _id),
      isIndex: true,
    },
    {
      text: en.SpotPage.pageLevelLinkText.spotForecast.text,
      title: en.SpotPage.pageLevelLinkText.spotForecast.title(name),
      path: spotForecastPath(slugify(name), _id),
      isIndex: false,
    },
  ];

  renderCombinedPageLevelLinks = () => {
    const { spotAssociated, feed } = this.props;
    const pageLinks = [
      {
        text: en.SpotPage.externalLinkText.region,
        path: spotAssociated.subregionUrl,
        newWindow: false,
      },
    ];
    if (feed.articles.length > 0) {
      pageLinks.push({
        text: en.SpotPage.externalLinkText.premiumAnalysis,
        path: `${spotAssociated.subregionUrl}/premium-analysis`,
        newWindow: false,
      });
    }
    if (spotAssociated.chartsUrl) {
      pageLinks.push({
        text: en.SpotPage.externalLinkText.charts,
        path: spotAssociated.chartsUrl,
        newWindow: false,
      });
    }
    return pageLinks;
  };

  /* TODO: Add react-router path for regional forecast */
  renderExternalLinks1 = () => {
    const { spotAssociated, feed } = this.props;
    const pageLinks = [
      {
        text: en.SpotPage.externalLinkText.region,
        path: spotAssociated.subregionUrl,
        newWindow: false,
      },
    ];
    if (feed.articles.length > 0) {
      pageLinks.push({
        text: en.SpotPage.externalLinkText.premiumAnalysis,
        path: `${spotAssociated.subregionUrl}/premium-analysis`,
        newWindow: false,
      });
    }
    return pageLinks;
  };

  renderExternalLinks2 = () => {
    const { spotAssociated, legacySubregionId } = this.props;
    const externalLinks = [
      {
        text: en.SpotPage.externalLinkText.buoys,
        path: buoySubregionUrl(legacySubregionId),
        newWindow: true,
      },
    ];

    if (spotAssociated.localPhotosUrl) {
      externalLinks.push({
        text: en.SpotPage.externalLinkText.photos,
        path: spotAssociated.localPhotosUrl,
        newWindow: true,
      });
    }

    if (spotAssociated.beachesUrl) {
      externalLinks.push({
        text: en.SpotPage.externalLinkText.travel,
        path: spotAssociated.beachesUrl,
        newWindow: false,
      });
    }
    return externalLinks;
  };

  onClickCard = swellEvent => {
    const { doTrackEvent, spot } = this.props;
    doTrackEvent('Clicked Swell Alert Card', {
      title: swellEvent.name,
      contentType: 'Swell Alert',
      basins: swellEvent.basins.join(','),
      locationCategory: 'Spot Page - Top',
      destinationUrl: swellEvent.permalink,
      subregionId: spot && spot.subregion ? spot.subregion._id : null,
    });
  };

  render() {
    const {
      spot,
      loading,
      nearbySpots,
      match: {
        params: { spotId },
      },
      report,
      multiCam,
      device,
      userSettings,
      favorites,
      doTrackEvent,
      doLoadTreatment,
      legacySpotId,
      idealSpotConditions,
      isPremium,
      userDetails,
      entitlements,
      spotAssociated,
      featuredContent,
      legacySubregionId,
      nearbyBuoys,
      doFetchBuoys,
      pageViews,
      swellEvents,
      treatments,
      premiumPerks,
      osData: { osName },
    } = this.props;

    const adTargets = [['spotid', spotId]];

    return (
      <div className="sl-spot-page">
        {(() => {
          if (loading) {
            return <PageLoading />;
          }
          if (spot) {
            return (
              <div>
                <SpotPageMeta
                  spotName={spot.name}
                  report={!!report}
                  multiCam={multiCam.isMultiCam}
                  spotId={spotId}
                  cameras={spot.cameras}
                />
                <RegistrationModals
                  createAccountUrl={config.createAccountUrl}
                  device={device}
                  doLoadTreatments={doLoadTreatment}
                  isPremium={isPremium}
                  pageViews={pageViews}
                  treatments={treatments}
                  userDetails={userDetails}
                />
                <ContentContainer>
                  {swellEvents.length ? (
                    <SwellEventCardContainer
                      onClickCard={swellEvent => this.onClickCard(swellEvent)}
                      events={swellEvents}
                    />
                  ) : null}
                  <ForecastHeader
                    breadcrumb={spot.breadcrumb}
                    spotName={spot.name}
                    pageTitle={`${spot.name} ${en.SpotPage.header.titleSuffix}`}
                    nearbySpots={nearbySpots}
                    showFavorite
                    spotPage
                    pageLevelLinks={this.renderCombinedPageLevelLinks()}
                    externalLinks1={this.renderExternalLinks2()}
                    userSettings={userSettings}
                    handleFavoriteClick={favorited => this.handleFavoriteClick(favorited, spotId)}
                    favorited={this.spotFavorited(favorites, spotId)}
                    doTrackEvent={doTrackEvent}
                    pageViews={pageViews}
                  />
                </ContentContainer>
                <SpotCurrentConditionsSection
                  spotId={spotId}
                  adTargets={adTargets}
                  featuredContent={featuredContent}
                />
                <div className="sl-spot-page__below-the-fold">
                  <ContentContainer>
                    <div className="sl-spot-report-page__charts">
                      <ForecastDataVisualizer
                        type="SPOT"
                        category="cams & reports"
                        pageName="Spot Forecast"
                        spotId={spotId}
                        spotName={spot.name}
                        utcOffset={spotAssociated.utcOffset}
                        subregionId={
                          spot.subregion && spot.subregion._id ? spot.subregion._id : null
                        }
                        extended
                        canToggleDataView
                        canToggleTimeView
                        spotPage
                        device={device}
                      />
                    </div>
                    {spotAssociated && legacySpotId && legacySubregionId ? (
                      <NearbyBuoys
                        fetchBuoys={() =>
                          doFetchBuoys(legacySpotId, legacySubregionId, {
                            units: spotAssociated.units.waveHeight,
                            timezone: spotAssociated.utcOffset,
                          })
                        }
                        nearbyBuoys={nearbyBuoys}
                        doTrackEvent={doTrackEvent}
                        isPremium={isPremium}
                        doLoadTreatments={doLoadTreatment}
                        spotId={spotId}
                      />
                    ) : null}
                    {premiumPerks && premiumPerks.perks && (
                      <PremiumBenefitsCenter
                        userDetails={userDetails}
                        isPremium={isPremium}
                        doTrackEvent={doTrackEvent}
                        premiumPerks={premiumPerks}
                        doLoadTreatment={doLoadTreatment}
                        spotId={spotId}
                        spotName={spot.name}
                      />
                    )}
                    <FeaturedContent
                      featuredContent={featuredContent}
                      doTrackEvent={doTrackEvent}
                      spotName={spot.name}
                      spotId={spotId}
                    />
                    <IdealConditions
                      name={spot.name}
                      href={idealConditionsUrl(legacySpotId)}
                      idealConditions={idealSpotConditions}
                      doTrackEvent={doTrackEvent}
                    />
                    <div className="sl-spot-page__below-the-fold__bottom-ad">
                      <GoogleDFP
                        unifiedAdMarketplace
                        adConfig={loadAdConfig('spotBottom', adTargets, entitlements)}
                      />
                    </div>
                  </ContentContainer>
                </div>
                {osName === 'iOS' && doLoadTreatment('sl_web_push_users_to_app') === 'on' ? (
                  <DeepLinkModal
                    spotId={spotId}
                    spotName={spot.name}
                    segment="report"
                    doTrackEvent={doTrackEvent}
                    device={device}
                  />
                ) : null}
              </div>
            );
          }
          return null;
        })()}
      </div>
    );
  }
}

SpotPage.defaultProps = {
  userDetails: null,
  spot: null,
  spotAssociated: null,
  loading: false,
  nearbySpots: null,
  userSettings: null,
  report: null,
  multiCam: null,
  favorites: [],
  savingFavorite: false,
  legacySubregionId: null,
  legacySpotId: null,
  featuredContent: null,
  reportData: null,
  swellEvents: [],
  treatments: {},
  osData: {
    osName: null,
  },
};

SpotPage.propTypes = {
  userDetails: userDetailsPropType,
  reportData: spotReportDataPropTypes,
  spot: PropTypes.shape({
    name: PropTypes.string,
    subregion: PropTypes.shape({
      _id: PropTypes.string,
      forecastStatus: PropTypes.string,
    }),
    breadcrumb: PropTypes.array,
    cameras: PropTypes.array,
  }),
  spotAssociated: spotAssociatedPropTypes,
  match: PropTypes.shape({
    params: PropTypes.shape({
      spotId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  report: PropTypes.shape(),
  multiCam: multiCamPropType,
  loading: PropTypes.bool,
  doSetRecentlyVisited: PropTypes.func.isRequired,
  doFetchSpotReport: PropTypes.func.isRequired,
  doFetchNearbySpots: PropTypes.func.isRequired,
  doFetchRegionalArticles: PropTypes.func.isRequired,
  doFetchSpotSwellEvents: PropTypes.func.isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
  nearbySpots: PropTypes.arrayOf(PropTypes.shape()),
  userSettings: userSettingsPropTypes,
  doToggleFavorite: PropTypes.func.isRequired,
  favorites: userFavoritesPropType,
  feed: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.bool,
    articles: PropTypes.arrayOf(articlePropTypes),
  }).isRequired,
  savingFavorite: PropTypes.bool,
  doTrackEvent: PropTypes.func.isRequired,
  doLoadTreatment: PropTypes.func.isRequired,
  legacySubregionId: PropTypes.string,
  legacySpotId: PropTypes.string,
  doFetchIdealConditions: PropTypes.func.isRequired,
  idealSpotConditions: spotIdealConditionsPropShape.isRequired,
  isPremium: PropTypes.bool.isRequired,
  entitlements: PropTypes.arrayOf(PropTypes.string).isRequired,
  doFetchsubregionAssociated: PropTypes.func.isRequired,
  featuredContent: featuredContentPropType,
  nearbyBuoys: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  doFetchBuoys: PropTypes.func.isRequired,
  doLeaveSpotRoute: PropTypes.func.isRequired,
  device: devicePropTypes.isRequired,
  pageViews: PropTypes.number.isRequired,
  swellEvents: swellEventsPropType,
  treatments: treatmentsPropType,
  doFetchPremiumPerks: PropTypes.func.isRequired,
  premiumPerks: premiumPerksPropType.isRequired,
  osData: osDataPropType,
};

export default withPageViews(
  connect(
    state => ({
      spot: getSpotDetails(state),
      loading: state.spot.report.loading,
      userDetails: getUserDetails(state),
      userSettings: getUserSettings(state),
      spotId: getSpotId(state),
      multiCam: getSpotMultiCam(state),
      report: getSpotReport(state),
      nearbySpots: getNearbySpots(state),
      nearbyBuoys: getSpotBuoys(state),
      reportData: getSpotReportData(state),
      spotAssociated: getSpotReportAssociated(state),
      favorites: getUserFavorites(state),
      savingFavorite: state.user.loading,
      legacySubregionId: getLegacySubregionId(state),
      legacySpotId: getLegacySpotId(state),
      idealSpotConditions: getSpotIdealConditions(state),
      isPremium: getPremiumStatus(state),
      entitlements: getUserEntitlements(state),
      advertisingIds: getAdvertisingIds(state),
      subregionAssociated: getSubregionAssociated(state),
      featuredContent: getFeaturedContent(state),
      feed: state.subregion.feed,
      swellEvents: getSwellEvents(state),
      treatments: getTreatments(state),
      premiumPerks: getPremiumPerks(state),
      osData: getOSData(state),
    }),
    dispatch => ({
      doFetchRegionalArticles: subregionId => dispatch(fetchRegionalArticles(subregionId)),
      doSetRecentlyVisited: (spotId, name) => dispatch(setRecentlyVisited('spots', spotId, name)),
      doFetchSpotReport: spotId => dispatch(fetchSpotReport({ spotId })),
      doFetchNearbySpots: spotId => dispatch(fetchNearbySpots(spotId)),
      doFetchSpotSwellEvents: spotId => dispatch(fetchSwellEvents(spotId, 'spot')),
      doToggleFavorite: (favorited, spotId) => dispatch(toggleFavorite(favorited, spotId)),
      doTrackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
      doLoadTreatment: treatment => dispatch(loadTreatment(treatment)),
      doNavigatedToPage: (event, properties) => dispatch(navigatedToPage(event, properties)),
      doFetchIdealConditions: legacySpotId => dispatch(fetchIdealConditions(legacySpotId)),
      doFetchsubregionAssociated: subregionId => dispatch(fetchOverviewData(subregionId)),
      doFetchBuoys: (legacySpotId, legacySubregionId, properties) =>
        dispatch(fetchBuoys(legacySpotId, legacySubregionId, properties)),
      doLeaveSpotRoute: () => dispatch(leaveSpotRoute()),
      doFetchPremiumPerks: () => dispatch(fetchPremiumPerks()),
    })
  )(withRouter(SpotPage)),
  'spotPage',
  'match.params.spotId'
);
